export const errorLocale = {
    ERROR_500: 'Что-то пошло не так...'
}